import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  main: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },

  licenseInfoTitle: {
    width: `calc(100% - ${theme.spacing(3)}px)`,
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),

    fontSize: 16,
  },
  subTitle: {
    fontSize: 14,
    textTransform: 'uppercase',
    lineHeight: '20px',
    letterSpacing: 1,
  },
  paperUpgrade: {
    height: 590,
    width: 480,

    padding: theme.spacing(1.5),
  },
  paperActivate: {
    height: 425,
    width: 480,

    padding: theme.spacing(1.5),
  },
  paper: {
    width: '680px',
    height: 'auto',
  },
  topBar: {
    height: '95px',
    backgroundColor: '#F6F6F6',
    padding: '12px 24px ',
    '@media (max-width: 960px)': {
      padding: '8px 24px ',
    },
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '133.4%',
    color: '#000000',
  },

  row: {
    alignItems: 'center',

    justifyContent: 'flex-start',
    padding: '24px',
    flexBasis: '45%',
    flexWrap: 'wrap',
    '& .MuiBox-root': {
      paddingTop: '0',
      paddingBottom: '0',
    },
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  blockbtn: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '20px 24px 24px 24px',
    flexBasis: '45%',
    flexWrap: 'wrap',
    '& .MuiBox-root': {
      paddingTop: '0',
      paddingBottom: '0',
    },
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
    '@media (max-width: 960px)': {
      padding: '12px 24px 24px 24px',
    },
  },
  blockbtn1: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 25px 22px 25px',
    flexBasis: '45%',
    flexWrap: 'wrap',
    '& .MuiBox-root': {
      paddingTop: '0',
      paddingBottom: '0',
    },
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
    '@media (max-width: 960px)': {
      padding: '12px 24px 24px 24px',
    },
  },
  license: {
    padding: '24px 24px 0 24px',
  },
  tabdetail: {
    padding: '12px 0 24px 0',
    display: 'flex',
    justifyContent: 'space-between',
  },
  featuredetail: {
    padding: '12px 0 12px 0px',
    display: 'flex',
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  flexBox: {
    display: 'flex',
  },
  formContainer: {
    flex: 1,
  },
  btn1: {
    marginRight: '12px',
    marginTop: theme.spacing(1),
    padding: '12px 22px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  btn2: {
    marginLeft: '12px',
    marginTop: theme.spacing(1),
    padding: '12px 22px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  tablabel: {
    minWidth: '33.33%',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 16,
    textTransform: 'capitalize',
  },
  tabsPanel: {
    width: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {},
  },
  tabs: {
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },

    '& .MuiTab-root.Mui-selected': {
      color: 'white',

      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      minWidth: '33%',
      padding: '16px 24px',
    },
    '& .MuiTabs-flexContainer': {
      padding: '0 24px 0 24px',
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  bartitle: {
    fontSize: '16px',
    fontWeight: 500,
  },
  features: {
    borderTop: '1px solid',
    padding: '12px 0 0 0',
    fontSize: '16px',
    fontWeight: 500,
  },
  addonBought: {
    fontSize: '12px',
    color: '#FF505F',
  },

  addfeatures: {
    padding: '10px 0 0 0',
    borderTop: '1px solid',
    fontSize: '16px',
    fontWeight: 500,
  },
  addfeatureCheckbox: {
    padding: '0 4px 0 9px',
    height: '6px',
  },
  tabBox: {
    '& > div > div': {
      padding: 0,
    },
  },
  tabdetailIcon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '17px',
  },
  icons: {
    color: 'rgba(0, 0, 0, 0.37)',
    fontSize: '13px',
    marginRight: '8px',
  },
  featureicons: {
    fontSize: '13px',
    marginRight: '8px',
    color: 'rgba(100, 201, 104, 1)',
  },
  featuredetailicon: {
    fontSize: '12px',
  },
  selctionfull: {
    padding: '24px 0 0 0',
  },
  priceBar: {
    display: 'flex',
    alignItems: 'center',
  },
  priceBox: {
    width: '170px',
  },
  price: {
    display: 'flex',
    fontSize: '20px',
    fontWeight: 600,
    color: '#FF505F',
  },
  subPrice: {
    height: '20px',
    display: 'flex',
    fontSize: '14px',
    fontWeight: 600,
  },
  stripe: {
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    border: '1px solid rgba(0, 0, 0, 0.18)',
    '& span': {
      textTransform: 'uppercase',
      fontWeight: 600,
    },
  },
  coreFeatures: {
    height: '125px',

    '@media (max-width: 960px)': {
      height: '125px',
      overflowY: 'auto',
    },
  },
  bothServices: {
    padding: '10px 0 0 0',
    fontSize: '16px',
    fontWeight: 500,
  },
}));
export const cardStyle = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: 'Arial, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#32325d',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
  hidePostalCode: true,
};
